import SelectizeWithEmpty from "../components/SelectizeWithEmpty";

export default class PrintConfigurations {
  new() {
    this.setupSelects();
  }

  create() {
    this.setupSelects();
  }

  edit() {
    this.setupSelects();
  }

  update() {
    this.setupSelects();
  }

  setupSelects() {
    SelectizeWithEmpty.init();
  }
}
